// Module
var code = "<mx-executor-grid data-grid=\"vm.grid\" enable-row-selection=\"::vm.enableRowSelection\" enable-selection-picker=\"::vm.enableSelectionPicker\" enable-drag-and-drop=\"::vm.enableDragAndDrop\" full-height=\"::vm.fullHeight\" min-height=\"::vm.minHeight\" data-label=\"::vm.title\" data-required=\"vm.required\"></mx-executor-grid>";
// Exports
export default code;